import axios, { AxiosInstance } from 'axios';
import { getModalDispatcher } from '../utils/ModalDispatcher';
import { logoutCore } from '../func/logout';

class Request {
  public customAxios: AxiosInstance;
  private static alertShown = false;

  constructor(baseURL: string, useUrlToken = false) {
    this.customAxios = axios.create({
      baseURL: baseURL,
    });

    this.customAxios.interceptors.request.use(
      (config) => {
        if (config.method && config.method.toLowerCase() !== 'get') {
          config.headers['Content-Type'] =
            config.data instanceof FormData
              ? 'multipart/form-data'
              : 'application/json';
        } else {
          delete config.headers['Content-Type'];
        }

        let token =
          localStorage.getItem('accessToken') === 'null'
            ? null
            : localStorage.getItem('accessToken');

        if (useUrlToken) {
          const tokenFromUrl = new URL(window.location.href).searchParams.get(
            'token',
          );
          if (
            tokenFromUrl &&
            tokenFromUrl !== 'null' &&
            tokenFromUrl !== 'undefined'
          ) {
            token = tokenFromUrl;
          }
        }

        if (token) {
          config.headers['Authorization'] = `Bearer ${token}`;
        } else {
          delete config.headers['Authorization'];
        }

        return config;
      },
      (error) => Promise.reject(error),
    );

    this.customAxios.interceptors.response.use(
      async (res) => {
        return res;
      },
      async (err: any) => {
        if (Request.alertShown) {
          return Promise.reject(err);
        }

        const msg = err.response?.data?.message;
        const modalDispatch = getModalDispatcher();

        if (
          msg === 'Authorization dose not exist' &&
          !window.location.pathname.startsWith('/')
        ) {
          Request.alertShown = true;
          if (modalDispatch) {
            modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
          } else {
            window.location.href = '/login';
            alert('로그인 후 이용해주세요.');
            window.location.href = '/login';
          }
          logoutCore();
        } else if (msg === 'jwt expired') {
          Request.alertShown = true;
          alert(
            '회원님의 정보 보호를 위해 자동 로그아웃되었습니다. 다시 로그인해 주세요.',
          );
          logoutCore();
          window.location.href = '/login';
        } else if (msg === 'invalid signature') {
          Request.alertShown = true;
          alert('로그인을 다시 해주세요.');
          logoutCore();
          window.location.href = '/login';
        } else if (msg === '권한이 없습니다.') {
          Request.alertShown = true;
          alert('권한이 없습니다.');
          const token = localStorage.getItem('accessToken');
          if (token) {
            window.location.href = '/payment/plan';
          } else {
            window.location.href = '/login';
          }
        }

        setTimeout(() => {
          Request.alertShown = false;
        }, 3000);

        return Promise.reject(err);
      },
    );
  }
  public get2 = async (endPoint: string, headers: any) => {
    return await this.customAxios.get(endPoint, headers);
  };
  public get = async (endPoint: string, config?: object) => {
    return await this.customAxios.get(endPoint, config);
  };
  public patch = async (endPoint: string, data: any) => {
    return await this.customAxios.patch(endPoint, data);
  };
  public post = async (endPoint: string, data: any) => {
    return await this.customAxios.post(endPoint, data);
  };
  public delete = async (endPoint: string, data?: any) => {
    return await this.customAxios.delete(endPoint, data);
  };
  public put = async (endPoint: string, data: any) => {
    return await this.customAxios.put(endPoint, data);
  };
}

export const req = new Request(
  `${process.env.REACT_APP_HOST_API || 'http://localhost:3333'}`,
);

export const req2 = new Request(
  `${process.env.REACT_APP_HOST_API_MAIN || 'http://localhost:3333'}`,
);

export const req3 = new Request(
  `${process.env.REACT_APP_HOST_API_UPBUILD || 'http://localhost:3333'}`,
);

export const reqNoAuth = new Request(
  `${process.env.REACT_APP_HOST_API || 'http://localhost:3333'}`,
  true,
);
